import { Button } from '@chakra-ui/react';
import { Link } from 'gatsby';
import React from 'react';
import xw from 'twin.macro';
import { ImageRenderer } from './imageRenderer';

interface Props {
  iomImages: any;
}

const styles = {
  heading: xw`text-3xl leading-9 tracking-tight font-extrabold sm:text-4xl sm:leading-10 mb-2`,
  subHeading: xw`mt-2 text-xl leading-7 font-semibold`,
  tag: xw`inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium leading-5 bg-indigo-200 text-black dark:text-white dark:bg-purple-600`,
};

function Component(props: Props) {
  const { iomImages } = props;

  return (
    <div className="relative px-4 pt-6 pb-6 mx-auto sm:px-6 lg:pt-12 lg:pb-28 lg:px-8 max-w-7xl">
      <h1
        className="mb-4 text-center text--color-heading-1"
        css={[styles.heading]}
      >
        Gallery
      </h1>
      <h3 className="mb-4 font-bold text-center text-brand-blue">
        Select album
      </h3>
      <div className="grid justify-center w-full mb-12 sm:space-x-6 gap-y-4 sm:flex">
        <Button size="md" variant="solid">
          Project Inspection
        </Button>
        <Button
          as={Link}
          size="md"
          to="/gallery/training-capacity-building"
          variant="outline"
        >
          Training & Capacity Building
        </Button>
      </div>
      <ImageRenderer images={iomImages} />
    </div>
  );
}

export const ProjectInspectionGallery = Component;
